
import { memo } from "react";
import { DashboardStats } from "./DashboardStats";
import { RecentDecisions } from "./RecentDecisions";
import { SubscriptionStatus } from "./SubscriptionStatus";
import { Decision } from "@/hooks/useDecisions";

interface DashboardContentProps {
  decisions: Decision[];
  onViewDecision: (id: string) => void;
  onNavigateToMyDecisions: () => void;
  onNavigateToMyDecisionsWithTag: (tag: string) => void;
  onNavigateToReviews: () => void;
  onNavigateToAnalytics: () => void;
  onNavigateToInsights: () => void;
  onUpgrade?: () => void;
}

const DashboardContent = memo(function DashboardContent({
  decisions,
  onViewDecision,
  onNavigateToMyDecisions,
  onNavigateToMyDecisionsWithTag,
  onNavigateToReviews,
  onNavigateToAnalytics,
  onNavigateToInsights,
  onUpgrade,
}: DashboardContentProps) {
  return (
    <div className="max-w-4xl mx-auto px-6 py-8 space-y-6">
      {onUpgrade && <SubscriptionStatus onUpgrade={onUpgrade} />}
      <DashboardStats
        decisions={decisions}
        onNavigateToReviews={onNavigateToReviews}
        onNavigateToMyDecisions={onNavigateToMyDecisions}
        onNavigateToMyDecisionsWithTag={onNavigateToMyDecisionsWithTag}
        onNavigateToAnalytics={onNavigateToAnalytics}
        onNavigateToInsights={onNavigateToInsights}
      />
      <RecentDecisions
        decisions={decisions.slice(0, 3)}
        onViewDecision={onViewDecision}
        onViewAll={onNavigateToMyDecisions}
      />
    </div>
  );
});

export { DashboardContent };
